import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOmega: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconOmega"><Path fillRule="evenodd" clipRule="evenodd" d="M12 4C8.41015 4 5.5 6.91015 5.5 10.5C5.5 13.4882 7.51725 16.0078 10.2661 16.7664L11 16.969V22H3V18H5V20H9V18.4551C5.78656 17.2426 3.5 14.1394 3.5 10.5C3.5 5.80558 7.30558 2 12 2C16.6944 2 20.5 5.80558 20.5 10.5C20.5 14.1394 18.2134 17.2426 15 18.4551L15 20H19V18H21V22H13L13 16.969L13.7339 16.7664C16.4828 16.0078 18.5 13.4882 18.5 10.5C18.5 6.91015 15.5899 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOmega;
